/**
 * English messages of the skin store (W2-01b skins-and-builtin-effects; ARCHITECTURE.md §12): why a skin could not
 * be installed, activated or removed, and what went wrong while resolving the default skin. Render code cannot import
 * the i18n runtime, so the store returns MessageRefs built from these keys (validation problems of a pack keep the
 * `respack.*` keys of formats/respack).
 *
 * Messages about one skin name it by its display name ({name}: the `name` of info.yml, as Settings > Skins lists
 * it), never by its storage id. Their params also carry {id} (not shown) so the UI can match a problem to a listed
 * skin. A skin that is not listed has no known name, so its messages do not name it at all.
 */

import { catalogOf, defineMessages } from '../../i18n/define';

export const m = defineMessages('skin', {
  notReady: 'Skins are still loading. Try again in a moment.',
  imageUndecodable: 'This browser cannot read the image {file} of the skin.',
  storageFailed: 'The skin could not be saved in this browser: {detail}',
  storageListFailed: 'The installed skins could not be read from this browser: {detail}',
  unknownSkin: 'This skin is not installed in this browser. It may have been removed.',
  localMissing: 'The Phigros skin in the local files is not available.',
  builtinNotRemovable: 'Built-in skins cannot be removed.',
  storedInvalid: 'The installed skin "{name}" is damaged and cannot be used.',
  storedUnreadable: 'The installed skin "{name}" could not be read from this browser: {detail}',
  localInvalid:
    'The Phigros skin in the local files cannot be used: {count, plural, one {# problem} other {# problems}} found.',
  localUnreachable: 'The Phigros skin in the local files could not be loaded: {detail}',
  proceduralFailed: 'The skin drawn by Phiedit could not be created: {detail}',
  defaultUnavailable: 'The chosen skin "{name}" could not be loaded, so another one is used.',
  defaultMissing: 'The skin chosen in the settings is not available, so another one is used.',
  initFailed: 'The skins could not be loaded: {detail}',
});

export default catalogOf(m);
